import createInitialSequence from "./utils/createInitialSequence";
import extractFileExtension from "./utils/extractFileExtension";
import splitStringIntoLines from "./utils/splitStringIntoLines.js";
import validateSequenceArray from "./utils/validateSequenceArray";
function fastaToJson(fileString, options = {}) {
  const ext = extractFileExtension(options.fileName);
  if (/^(faa)$/.test(ext)) {
    options.isProtein = true;
  }
  let resultArray = [];
  let result = null;
  try {
    const lines = splitStringIntoLines(fileString);
    for (let i = 0; i < lines.length; i++) {
      parseLine(lines[i]);
    }
    if (result) {
      resultArray.push(result);
      result = null;
    }
  } catch (e) {
    console.error("error:", e);
    console.error("error.stack: ", e.stack);
    resultArray = [
      {
        success: false,
        messages: ["Import Error: Invalid File"]
      }
    ];
  }
  return validateSequenceArray(resultArray, options);
  function parseLine(line) {
    line = line.trim();
    if (";" === line[0]) {
      if (result) {
        return;
      }
      result = createInitialSequence(options);
      parseTitle(line);
    } else if (">" === line[0]) {
      if (result) {
        resultArray.push(result);
        result = null;
      }
      result = createInitialSequence(options);
      parseTitle(line);
    } else {
      if (!result) {
        result = createInitialSequence(options);
      }
      parseSequenceLine(line);
    }
    if (options && options.parseFastaAsCircular) {
      result.parsedSequence.circular = true;
    }
  }
  function parseTitle(line) {
    if (options && "parseName" in options && !options.parseName) {
      result.parsedSequence.name = line.slice(1);
      return;
    }
    const pipeIndex = line.indexOf("|");
    if (pipeIndex > -1) {
      result.parsedSequence.name = line.slice(1, pipeIndex);
      result.parsedSequence.description = line.slice(pipeIndex + 1);
    } else {
      result.parsedSequence.name = line.slice(1);
    }
  }
  function parseSequenceLine(line) {
    result.parsedSequence.sequence += line;
  }
}
export default fastaToJson;
